module.exports = __webpack_public_path__ + "img/43.530e16c9.png";